export const useSSO = () => {
  const getSSOFromURL = () => {
    const { hostname } = window.location;
    if (hostname.includes('savencia')) return 'saml.savencia';
    else return '';
  };

  return { getSSOFromURL };
};
